export default class InputPerson
{
  constructor(id, person, photo) 
  {    
    this.id = id;
    this.person = person;
    this.photo = photo;
  }    
}